import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class DataCatalogService {
  async getAllDCs({ search, limit, page, orderBy, order, tags, tz }) {
    return (
      await fetchApi.post(`/dataCatalog/list`, {
        limit,
        page,
        orderBy,
        order,
        tags,
        search,
        tz,
      })
    ).data;
  }

  async getDCDetail(DataCatalog_id, { TypeId, search, orderBy, order }) {
    return (
      await fetchApi.get(
        `/dataCatalog/${DataCatalog_id}?TypeId=${TypeId}&orderBy=${orderBy}&order=${order}${
          search ? `&search=${encodeURIComponent(search)}` : ""
        }`
      )
    ).data;
  }

  async getTags() {
    return (await fetchApi.get(`/dataCatalog/tags`)).data;
  }
}
